import React from 'react';
import { node, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import Corner from '../Corner';
import { POSITIONS } from '../constants';
import styles from './index.module.scss';

const positionToClassName = {
    TOP_LEFT: styles.topLeft,
    TOP_RIGHT: styles.topRight,
    BOTTOM_LEFT: styles.bottomLeft,
    BOTTOM_RIGHT: styles.bottomRight
};

const IconContainer = ({ children, position, showIconRing }) => {
    if (!children) {
        return null;
    }

    const ringClassName = classNames('flex', positionToClassName[position], styles.withRing);

    return (
        <Corner className={styles.iconContainer} position={position}>
            {showIconRing && <div className={ringClassName}>{children}</div>}
            {!showIconRing && children}
        </Corner>
    );
};

IconContainer.propTypes = {
    children: node.isRequired,
    position: oneOf(Object.values(POSITIONS)),
    showIconRing: bool
};

IconContainer.defaultProps = {
    position: POSITIONS.BOTTOM_RIGHT,
    children: null,
    showIconRing: true
};

export default IconContainer;
